import { render, staticRenderFns } from "./_Transport.vue?vue&type=template&id=94c783e8&"
import script from "./_Transport.vue?vue&type=script&lang=js&"
export * from "./_Transport.vue?vue&type=script&lang=js&"
import style0 from "./_Transport.vue?vue&type=style&index=0&id=94c783e8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports